import { AnyAction, Dispatch } from 'redux';

import { AggregationCountsApi } from '@ClientApi/aggregationCountsApi';
import { ISearchTransactionsParams } from '@Shared/interfaces/Filters';

export const ADD_AGGREGATION_COUNTS = 'ADD_AGGREGATION_COUNTS';
export const SET_AGGREGATION_COUNTS_LOADING = 'SET_AGGREGATION_COUNTS_LOADING';

export class AddAggregationCounts {
  readonly type = ADD_AGGREGATION_COUNTS;
  constructor(
    public payload: {
      match: string;
      aggregationCounts: { [key: string]: number };
    }
  ) {}
}

export class SetAggregationCountsLoading {
  readonly type = SET_AGGREGATION_COUNTS_LOADING;
  constructor(
    public payload: {
      match: string;
      loading: boolean;
    }
  ) {}
}

export const getAggregationCounts =
  (dispatch: Dispatch<AnyAction>) => async (match: string, params: Omit<ISearchTransactionsParams, 'limit' | 'offset'>) => {
    dispatch(
      new SetAggregationCountsLoading({
        match,
        loading: true
      })
    );
    const aggregationCounts = await AggregationCountsApi.loadAggregationCounts(match, params);
    dispatch(
      new AddAggregationCounts({
        match,
        aggregationCounts: aggregationCounts.redux[match]
      })
    );
    dispatch(
      new SetAggregationCountsLoading({
        match,
        loading: false
      })
    );
  };

export type AggregationCountsAction = AddAggregationCounts | SetAggregationCountsLoading;
